module.exports = __webpack_public_path__ + "static/media/download.7d7c928c.svg";